import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';
import { resolveMsg } from './messageHelper';

const INITIAL_STATE = {
    erroDeSolicitacao:null,
    drsciEmitida: null,
    dadosDrsci: null,
    esperandoSolicitacao: false,
    itemDrsci: {},
    objErro: {primaryText: '', secondaryText: ''},
  
};

export default (state= INITIAL_STATE, action) => {
    switch(action.type){

        case 'DRSCI_SOLICITADO':
            return {...state, esperandoSolicitacao: true, mensagem: ''};

        case 'DRSCI_RECEBIDO':
            return {...state, dadosDrsci: action.payload, esperandoSolicitacao: false, erroDeSolicitacao: false, dirty: false };

        case 'DRSCI_ERRO_RECEBIDO':
            return {...state, esperandoSolicitacao: false, erroDeSolicitacao: true, mensagem: (typeof action.payload == "string") ? action.payload : MSG_ERRO_SERVIDOR};

        case 'DRSCI_EMITIR_DECLARACAO_SOLICITADO':
            return {...state, esperandoEmissao: true, mensagem: '', mensagemNegocio: ''};

        case 'DRSCI_EMITIR_DECLARACAO_RECEBIDO':
            let id = action.payload.numero ? action.payload.numero : action.payload.id;
            return {
                ...state, 
                itemDrsci: {...state.itemDrsci, [id]: action.payload},
                esperandoEmissao: false,
                esperandoSolicitacao: false,
                redirectUrl: '/drsci/' + id,
                dirty: true
            };

        case 'DRSCI_EMITIR_DECLARACAO_ERRO_RECEBIDO':
            return {
                ...state,
                mensagem: (typeof action.payload == "string") ? action.payload : MSG_ERRO_SERVIDOR,
                esperandoEmissao: false,
                esperandoSolicitacao: false
            };

        case 'DRSCI_ERRO_NEGOCIO_RECEBIDO':
                return {...state, mensagemNegocio: "", mensagem:"", esperandoEmissao: false, 
                objErro: resolveMsg(action.payload)}

        case 'DRSCI_CONSULTA_RECEBIDA':
            return {...state, itemDrsci: {...state.itemDrsci, [action.payload.numero]: action.payload.data}, esperandoSolicitacao: false};

        case 'DRSCI_LIMPAR_DETALHE':
            return {...state, itemDrsci: {} };

        case 'DRSCI_EMITIR_DECLARACAO_MENSAGEM':
            return {...state, mensagem: action.payload, esperandoSolicitacao: false };

        //IMPRESSAO PDF
        case 'DRSCI_IMPRESSAO_SOLICITADA':
            return {...state,esperandoImpressao: true, mensagem: ''};
        case 'DRSCI_IMPRESSAO_ERRO':
            return {...state,esperandoImpressao: false,mensagem: action.payload};
        case 'DRSCI_IMPRESSAO_RECEBIDA':
            return {...state,esperandoImpressao: false, mensagem: ''};        

        default:
           return state;
    }
}